export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/textSegmentationWorker.4c293503.worker.js");
}
